import { useRef, useEffect } from 'react'

const isMac = () => navigator.userAgent.toLowerCase().includes('mac')

/**
 * Attaches document keydown listener for undo shortcuts while drawing is active.
 *
 * Ctrl+Z (Win) / Cmd+Z (Mac) → onRemoveLastDot
 * Backspace / Delete (when not focused on an input) → onRemoveLastDot
 */
export const useLassoKeyboard = ({ onRemoveLastDot, enabled }) => {
  const onRemoveLastDotRef = useRef(onRemoveLastDot)

  useEffect(() => {
    onRemoveLastDotRef.current = onRemoveLastDot
  })

  useEffect(() => {
    if (!enabled) return

    const handleKeyDown = event => {
      const keyCode = event.keyCode || event.which
      const mac = isMac()
      const isCtrl =
        (event.ctrlKey && !event.altKey && !event.shiftKey && !mac) ||
        (event.metaKey && !event.ctrlKey && !event.shiftKey && mac)

      if (isCtrl && keyCode === 90) {
        // Ctrl+Z or Cmd+Z
        onRemoveLastDotRef.current?.()
        return false
      }

      if (!isCtrl && (keyCode === 8 || keyCode === 46)) {
        // Backspace or Delete — only when not typing in an input
        const tag = document.activeElement?.tagName?.toLowerCase()
        if (tag !== 'input' && tag !== 'textarea') {
          onRemoveLastDotRef.current?.()
          return false
        }
      }

      return true
    }

    document.addEventListener('keydown', handleKeyDown)
    return () => document.removeEventListener('keydown', handleKeyDown)
  }, [enabled])
}
